'use client'
export const Theme = ({mainColor}) => {
    return  {
        mainBg: "#f2ffda",
        secondaryBg: "#050917",
        mainColor: mainColor ? mainColor : "#FF6978",
        secondaryColor: "#5F0994",
        accentColor: "#696dba",
        errorColor: "#ff0000",
        warningColor:"#ff9800",
        infoColor: "#2196F3",
        successColor:"#04AA6D",
        background: 'white'
    }
};

export const LightTheme = ({mainColor}) => {
    return  {
        mainBg: "#f2ffda",
        secondaryBg: "#050917",
        mainColor: mainColor ? mainColor : "#FF6978",
        secondaryColor: "#209409",
        accentColor: "#69ba97",
        errorColor: "#ff0000",
        warningColor:"#ff9800",
        infoColor: "#2196F3",
        successColor:"#04AA6D",
        background: 'white'
    }
};

export const DarkTheme = ({ mainColor }) => {
    return {
        // A deep space-navy tint that pairs perfectly with your coral/pink mainColor
        mainBg: "#080c16", 
        
        // A slightly lighter surface navy for cards, sidebars, and elevated containers
        secondaryBg: "#f2ffda", 
        
        // Kept exactly the same as requested
        mainColor: mainColor ? mainColor : "#FF6978", 
        
        // Shifted from deep royal purple to a visible, glowing electric neon-purple
        secondaryColor: "#b266ff", 
        
        // Brightened slightly for high contrast readability against dark backgrounds
        accentColor: "#868be3", 
        
        // Softened status colors slightly to prevent harsh eye strain on dark UI
        errorColor: "#ff4d4d",
        warningColor: "#ffb74d",
        infoColor: "#4fc3f7",
        successColor: "#05c483",
        
        // Used for input fields, canvas layers, or main text boxes
        background: "#0d1324" 
    }
};
